// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container1 {
    /* margin:10px */
    font-family: "Roboto";
    width: 100%;
}

.body {
    padding: 10px;
}

.footer {
    margin-top: 50px;
    background-color: #f7f7f7;
    padding: 10px;
    border-top: 1px solid #cfd3d6;
    border-bottom: 1px solid #cfd3d6;
}

.admission-heading{
    color: #a74343;
}
.textFieldContainer{
    display: flex;
    flex-direction: column;
}
.textInput{
    padding: 5px;
    border-radius: 4px;
    margin-bottom: 15px;
}
.selectInput{
    border: 2px solid #000000;
    padding: 5px;
    border-radius: 4px;
    margin-bottom: 15px;
}
.submitButton {
    color: white;
    padding: 10px;
    background-color: rgb(8, 100, 176);
    border: none;
    border-radius: 5px;
}

.disabledButton {
    color: white;
    padding: 10px;
    background-color: #dddddd;
    border: none;
    border-radius: 5px;
}

.basic-details-card{
    border: 1px solid #cfd3d6;
    border-radius: 5px;
}

.basic-details-field-container{
    display: flex;
    justify-content: space-between;
}

.basic-details-field-key{
    font-size: 14px;
}

.basic-details-field-value{
    display: flex;
    justify-content: flex-end;
    width: 72%;
    font-size: 13px;
    font-weight: 500;
    /* word-wrap: break-word; */
    word-break: break-all;
}

.term-details-card{
    border: 1px solid #cfd3d6;
    border-radius: 5px;
}

.term-details-field-container{
    display: flex;
    justify-content: space-between;
}
.term-details-field-key{
    font-size: 14px;
}
.term-details-field-value{
    display: flex;
    justify-content: flex-end;
    width: 65%;
    font-size: 14px;
    font-weight: 500;
    /* word-wrap: break-word; */
    word-break: break-all;
}

.error-msg{
    margin-top: 5px;
    color: #F77777;
}
.hrow {
    height: 2px;
    background-color: black;
    margin-bottom: 15px;
}
.info-container{
    display: flex;
    flex-direction: column;
}
.info-heading{
    color: #a74343;
    font-size: 18px;
}
.info-field-container{
    display: flex;
    justify-content: space-between;
}
.info-field-key{
    font-size: 14px;
}
.info-field-value{
    display: flex;
    justify-content: flex-end;
    width: 65%;
    font-size: 14px;
    font-weight: 500;
    /* word-wrap: break-word; */
    word-break: break-all;
}

.web-view{
    display: none;
}

@media (min-width:577px) {
    .textFieldContainer{
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .textInput{
        margin-bottom: 0px;
        margin-right: 10px;
        width: 17%;
        height: 44px;
    }
    .selectInput{
        width: 17%;
        margin-bottom: 0px;
        margin-right: 10px;
        height: 44px;
    }
    .submitButton{
        width: auto;
    }
    .web-view{
        display: block;
    }
    .mobile-view{
        display: none;
    }
}



`, "",{"version":3,"sources":["webpack://./src/components/admission/Admission.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;QACV,YAAY;IAChB;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container1 {\n    /* margin:10px */\n    font-family: \"Roboto\";\n    width: 100%;\n}\n\n.body {\n    padding: 10px;\n}\n\n.footer {\n    margin-top: 50px;\n    background-color: #f7f7f7;\n    padding: 10px;\n    border-top: 1px solid #cfd3d6;\n    border-bottom: 1px solid #cfd3d6;\n}\n\n.admission-heading{\n    color: #a74343;\n}\n.textFieldContainer{\n    display: flex;\n    flex-direction: column;\n}\n.textInput{\n    padding: 5px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n}\n.selectInput{\n    border: 2px solid #000000;\n    padding: 5px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n}\n.submitButton {\n    color: white;\n    padding: 10px;\n    background-color: rgb(8, 100, 176);\n    border: none;\n    border-radius: 5px;\n}\n\n.disabledButton {\n    color: white;\n    padding: 10px;\n    background-color: #dddddd;\n    border: none;\n    border-radius: 5px;\n}\n\n.basic-details-card{\n    border: 1px solid #cfd3d6;\n    border-radius: 5px;\n}\n\n.basic-details-field-container{\n    display: flex;\n    justify-content: space-between;\n}\n\n.basic-details-field-key{\n    font-size: 14px;\n}\n\n.basic-details-field-value{\n    display: flex;\n    justify-content: flex-end;\n    width: 72%;\n    font-size: 13px;\n    font-weight: 500;\n    /* word-wrap: break-word; */\n    word-break: break-all;\n}\n\n.term-details-card{\n    border: 1px solid #cfd3d6;\n    border-radius: 5px;\n}\n\n.term-details-field-container{\n    display: flex;\n    justify-content: space-between;\n}\n.term-details-field-key{\n    font-size: 14px;\n}\n.term-details-field-value{\n    display: flex;\n    justify-content: flex-end;\n    width: 65%;\n    font-size: 14px;\n    font-weight: 500;\n    /* word-wrap: break-word; */\n    word-break: break-all;\n}\n\n.error-msg{\n    margin-top: 5px;\n    color: #F77777;\n}\n.hrow {\n    height: 2px;\n    background-color: black;\n    margin-bottom: 15px;\n}\n.info-container{\n    display: flex;\n    flex-direction: column;\n}\n.info-heading{\n    color: #a74343;\n    font-size: 18px;\n}\n.info-field-container{\n    display: flex;\n    justify-content: space-between;\n}\n.info-field-key{\n    font-size: 14px;\n}\n.info-field-value{\n    display: flex;\n    justify-content: flex-end;\n    width: 65%;\n    font-size: 14px;\n    font-weight: 500;\n    /* word-wrap: break-word; */\n    word-break: break-all;\n}\n\n.web-view{\n    display: none;\n}\n\n@media (min-width:577px) {\n    .textFieldContainer{\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n    }\n    .textInput{\n        margin-bottom: 0px;\n        margin-right: 10px;\n        width: 17%;\n        height: 44px;\n    }\n    .selectInput{\n        width: 17%;\n        margin-bottom: 0px;\n        margin-right: 10px;\n        height: 44px;\n    }\n    .submitButton{\n        width: auto;\n    }\n    .web-view{\n        display: block;\n    }\n    .mobile-view{\n        display: none;\n    }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
